<table class="selectableTable">
  <tr>
    <th>Type</th>
    <th>Name</th>
    <th>Details</th>
  </tr>
  @for (
    item of this.dataSource.data;
    track item.id;
    let even = $even;
    let odd = $odd
  ) {
    @if (item.id != undefined) {
      <tr
        id="trsummary_{{ item.id }}"
        [ngClass]="{ even: even, odd: odd }"
        class="rowSummary highlightable"
        (click)="selectRow_click(item.id)"
      >
        <td style="width: 10%">
          <mat-icon title="{{ getTypeTitle(item.type) }}">{{
            getTypeIcon(item.type)
          }}</mat-icon>
        </td>
        <td style="width: 25%">{{ item.name }}</td>
        <td
          style="width: 65%"
          [innerHTML]="
            formatDetails(item.type, item.details) | safeHtml: 'html'
          "
        ></td>
      </tr>
    }
    @if (this.options.selectAction == 'expand') {
      <tr
        id="trdetails_{{ item.id }}"
        class="rowDetails noHover"
        style="display: none"
      >
        <td colspan="6">
          <div style="height: 100px">[helpful at-a-glance info goes here]</div>
        </td>
      </tr>
    }
  }
</table>
